abstract class CollectionPanel extends BaseView {

	protected header: HTMLElement;

	protected searchBarContainer: HTMLElement;

	protected searchInp: HTMLInputElement;

	protected searchLbl: HTMLInputElement;

	protected cHeader: HTMLElement;

	protected cActions: HTMLElement;

	protected cHeaderTitle: HTMLElement;

	protected collectionTitleEl: HTMLSpanElement;

	protected bBody: HTMLElement;

	protected itemsWrap: HTMLElement;

	protected collectionActions: HTMLElement;

	protected collectionFilter: HTMLElement;

	protected cSearchControl: HTMLElement;

	protected cFilterControl: HTMLElement;

	protected cContextMenu: HTMLElement;

	protected collectionTypeTitle: HTMLElement;

	protected resultsView: ResultViews;

	protected infoPanel: InfoPanel;

	protected recordSelection: CollectionSelection;

	protected emptyCollection: HTMLElement;

	protected emptyCollectionsTitle: HTMLElement;

	protected emptyCollectionsTxt: HTMLElement;

	protected emptyCollectionTitle: HTMLElement;

	protected emptyCollectionTxt: HTMLElement;

	protected errorCollectionTitle: HTMLElement;

	protected errorCollectionTxt: HTMLElement;

	protected emptyCollectionContent: HTMLElement;

	protected sortableInstance: object;

	// "Download all" button will implemented later
	// protected downloadBtn: HTMLElement;

	/**
	 *
	 * @protected
	 */
	protected aclBtn: Element;

	/**
	 *
	 * @private
	 */
	private PageSize = 48;

	/**
	 * Collection type title
	 * @protected
	 */
	protected title: string;

	/**
	 * Is this a collections view or a records view
	 * @protected
	 */
	protected isCollectionView: boolean = true;

	/**
	 * Current collection (if its a record view)
	 * @protected
	 */
	protected currentCollection: CollectionData;

	/**
	 *
	 * @protected
	 */
	protected bannerHeight: number = 0;

	/**
	 *
	 * @protected
	 */
	protected pageNo: number = 0;

	/**
	 *
	 * @protected
	 */
	protected currentViewType: number;

	/**
	 * Collection type (All, mine, shared)
	 * @protected
	 */
	protected type: number;

	/**
	 * All (null), audio, document, video, clip
	 * @protected
	 */
	protected mediaFilter: string;

	/**
	 * Data for the list of collections
	 * @private
	 */
	private collectionsData: {
		numHits: number,
		items: Array<any>
	};

	/**
	 * True if we are loading
	 * @private
	 */
	private loading: boolean = false;

	/**
	 * ID of the saved search if this is a smart collection
	 * @private
	 */
	private smartId: number = null;

	/**
	 *
	 * @private
	 */
	private shareLink: ShareLink;

	/**
	 * Selected sort for collection view
	 * @private
	 */
	public sort: any;

	/**
	 * Sort element
	 * @private
	 */
	private sortEl: any;

	/**
	 * Sort options
	 * @private
	 */
	private readonly sortOpts: any;

	/**
	 *
	 * @param title
	 * @protected
	 */
	protected constructor(title: string) {
		super();
		this.currentCollection = null;
		this.title = title;
		this.mediaFilter = '';
		this.currentViewType = iwStorage.get('CollectionsView') ? iwStorage.getObject('CollectionsView') : ViewType.grid;

		this.sortOpts = {};
		this.sortOpts[iwi18n.gettext('collections', 'Creation Date (Newest first)')] = 'creationDate DESC';
		this.sortOpts[iwi18n.gettext('collections', 'Creation Date (Oldest first)')] = 'creationDate ASC';
		this.sortOpts[iwi18n.gettext('collections', 'Modified Date (Newest first)')] = 'modifiedDate DESC';
		this.sortOpts[iwi18n.gettext('collections', 'Modified Date (Oldest first)')] = 'modifiedDate ASC';
		this.sortOpts[iwi18n.gettext('collections', 'Collection Name (A - Z)')] = 'title ASC';
		this.sortOpts[iwi18n.gettext('collections', 'Collection Name (Z - A)')] = 'title DESC';

		this.getEnquireData();
	}

	/**
	 * Add enquiry items to an existing menu group
	 */
	private getEnquiryMenuGroup() {
		// loop over all enquiry forms user has access too and create a context menu item for it
		let arr = [];
		if (EnquiryData.data && !iwCore.isEmptyObject(EnquiryData.data)) {
			let parsedModel;
			for (let zoneId in EnquiryData.data) {
				if (EnquiryData.data.hasOwnProperty(zoneId)) {
					parsedModel = JSON.parse(EnquiryData.data[zoneId]);
					arr.push(
						{
							name: parsedModel['headerText'] || iwi18n.gettext(undefined, 'Enquire'),
							icon: 'iw-icon-email',
							cbFn: this.enquire.bind(this,zoneId),
							// each form has a unique condition
							condition: 'iwcanenquire_'+zoneId,
						}
					)
				}
			}
		} else if (EnquiryData.isLegacy) {
			arr.push(
				{
					name: iwi18n.gettext(undefined, 'Enquire'),
					icon: 'iw-icon-email',
					cbFn: this.enquire.bind(this,null),
					condition: 'iwcanenquire'
				}
			);
		}

		return arr;
	}

	/**
	 * Create context menu items
	 */
	private setMenuArray(): void {
		let viewGroup = [
				{name: iwi18n.gettext(undefined,'View'), icon: 'iw-icon-view', cbFn: this.openFromContext.bind(this), condition: 'iwisparent'},
				{name: iwi18n.gettext('collections', 'Share via link'), icon: 'iw-icon-view', cbFn: (params: any) => {
						if (this.currentCollection) {
							this.shareLink = new ShareLink(this.currentCollection, this.currentCollection.publicUrl, this.smartId);
						} else {
							const collectionData = {
								id: params.iwcollection_id,
								smartId: params.iwsmartid,
								publicUrl: decodeURIComponent(params.iwcollection_public_url)
							}
							this.shareLink = new ShareLink(collectionData, collectionData.publicUrl, collectionData.smartId);
						}
						this.shareLink.createModal();
					}, condition: 'iwcanshare'},
			],
			editGroup = [
				{name: iwi18n.gettext('collections', 'Edit %1 name', iw.collectionsName), icon: 'iw-icon-edit', cbFn: (params: any) => {this.editFromContext(params, 'title');}, condition: 'iwusercanedit'},
				{name: iwi18n.gettext('collections', 'Edit %1 description', iw.collectionsName), icon: 'iw-icon-edit', cbFn:(params: any) => {this.editFromContext(params, 'description');}, condition: 'iwusercanedit'}
			],
			actionGroup = [
				{name: iwi18n.gettext('collections', 'Add all to basket'), icon: 'iw-icon-basket', cbFn: 'SystemBasketController.addAllFromCollection', condition: 'iwbasketsenabled'},
				{name: iwi18n.gettext('collections','Run workflow on all'), icon: 'iw-icon-workflow', cbFn: this.runWorkflowOnAll.bind(this), condition: 'iwcanrunworkflowonall'},
				{name: iwCore.capitaliseFirst(iwi18n.gettext('collections','%1 all download...',  iw.ordersTitleTerm)), icon: 'iw-icon-order', cbFn: 'CISSendJobWidgets.sendAll', condition: 'iwshowdownload'},
				{name: iwCore.capitaliseFirst(iwi18n.gettext('collections','%1 all download for...', iw.ordersTitleTerm)), icon: 'iw-icon-order', cbFn: 'CISSendJobWidgets.sendAllFor', condition: 'iwshowdownloadfor'}
			].concat(this.getEnquiryMenuGroup()),
			deleteGroup = [
				{name: iwi18n.gettext('collections', 'Delete this %1', iw.collectionsName), icon: 'iw-icon-remove', delete: true, cbFn: this.deleteCollection.bind(this), condition: 'iwusercanedit'},
			];

		iwMenu.setMenuArray('collectionCtx', {
			title: iwCore.capitaliseFirst(iwi18n.gettext('collections', '%1 options', iw.collectionsName)),
			groups: [viewGroup, editGroup, actionGroup, deleteGroup]
		});
	}

	/**
	 *
	 * @protected
	 */
	protected setUpEvents(): void {
		EVENT.attach(this.bBody, 'viewChange', (e: any) => {
			if (this.currentViewType !== e.detail.view) {
				this.currentViewType = e.detail.view;
				iwStorage.setObject('CollectionsView', e.detail.view);
				this.resultsView.updateActive(this.currentViewType);
				iwCore.clearElement(this.itemsWrap);

				if (this.currentCollection) {
					this.currentCollection.items = [];
				}

				if (this.recordSelection) {
					this.recordSelection.clearSelect();
				}

				if (this.infoPanel && this.infoPanel.panelModel && this.infoPanel.panelModel.recordPreviewIndex >= 0) {
					this.infoPanel.panelModel.recordPreviewIndex = null;
				}

				if (this.collectionsData) {
					this.collectionsData.items = [];
				}

				this.pageNo = 0;

				this.setViewClassName(this.bBody);
				this.getData();
			}
		});

		EVENT.attach(this.searchInp, 'keydown', (e: any) => {
			if (e.key === 'Enter') {
				this.collectionsData.items = [];
				this.pageNo = 0;
				iwCore.clearElement(this.itemsWrap);
				this.getData();
				this.searchInp.blur();
			}
		});

		// show/hide search for smaller screens
		EVENT.attach(this.cSearchControl, 'click', () => {
			iwCore.toggleClassName(this.mainContainer, 'cSearch-isActive');
		});

		EVENT.attach(this.collectionTypeTitle, 'click', () => this.openCollections());

		EVENT.attach(this.cFilterControl, 'click', () => this.openFilterActions());

		//store screen width before resize
		let windowWidth = window.innerWidth;
		EVENT.attach(window, 'windowResized', () => {
			// Check if the viewport width changes to make sure the resize event is not being triggered on iOS mobile scroll (when the browser address bar hides/ shows)
			// Compare screen width with stored value before size with current value
			if (windowWidth !== window.innerWidth) {
				if (this.currentCollection) {
					iwCore.removeClassName(this.mainContainer, 'cInfoPanel-isActive');
				}
				windowWidth = window.innerWidth;
			}
			this.resize();
		});

		EVENT.attach(this.bBody, 'scroll', () => {
			// check that the bBody has children to make sure this hasn't been triggered by us clearing it out
			if (this.bBody.children.length && this.bBody.scrollHeight - Math.round(this.bBody.scrollTop) - this.bBody.clientHeight < 65 && !this.loading) {
				if ((this.currentCollection && this.pageNo < Math.ceil(this.currentCollection.numHits/this.PageSize) - 1) ||
					this.collectionsData && this.pageNo < Math.ceil(this.collectionsData.numHits/this.PageSize) - 1) {
					this.loading = true;
					this.pageNo++;
					this.getData();
				}
			}
		});

		EVENT.attach(document, 'RecordResult', (e: CustomEvent) => {
			let dItem = e.detail.deleteItem;
			if (dItem && this.itemsWrap === dItem.mainContainer.parentElement) {
				let index = this.currentCollection.items.findIndex((f: any) => f.recordID === dItem.recordID);
				this.currentCollection.items.splice(index, 1);

				this.itemsWrap.removeChild(dItem.mainContainer);
				if (this.itemsWrap.children.length === 0) {
					this.renderEmpty(this.currentCollection);
				}
			}
		});

		EVENT.attach(document, 'InfoPanel', (e: CustomEvent) => {
			this.replaceCollectionCtx();
			if (e.detail.titleChange) {
				this.collectionTitleEl.textContent = e.detail.value;
				if (this.recordSelection && this.recordSelection.batchName) {
					this.recordSelection.batchName = e.detail.value;
				}
				this.searchInp.placeholder = iwi18n.gettext(undefined, 'Search %1', e.detail.value.toLowerCase());
			} else if (e.detail.loadMore) {
				if (this.pageNo < Math.ceil(this.currentCollection.numHits/this.PageSize) - 1) {
					this.loading = true;
					this.pageNo++;
					this.getData();
				}
			}
		});

		EVENT.attach(document, 'bannerAdjusted', this.resize.bind(this));
		EVENT.attach(document, 'bannerDismissed', this.resize.bind(this));
		EVENT.attach(document, 'resizeTrigger', this.resize.bind(this));

		EVENT.attach(this.bBody,"touchmove", () => {
			let breakPoint = iwCore.browser.breakPoint(window.innerWidth, window.innerWidth),
				header = document.getElementById('header') || document.getElementsByTagName('header')[0];

			if (breakPoint === 'mobile') {
				// For Safari
				document.body.scrollTop = header.clientHeight;
				// For Chrome, Firefox, IE and Opera
				document.documentElement.scrollTop = header.clientHeight;
			}
		},{once : true}, true);
	}

	/**
	 *
	 * @private
	 */
	private resize() {
		let height = this.pageHeight();
		if (this.infoPanel) {
			this.infoPanel.resize(height);
		}
	}

	/**
	 * Get collections data
	 * @protected
	 */
	protected getData(id?: number | string) {
		id = id || (this.currentCollection ? this.currentCollection.id : null);

		requestAnimationFrame(function() {
			EVENT.custom('CollectionPanel', {id: id});
		});

		iwCore.ajax({
			url: '/collections/getcollection' + (id ? '' : 's'),
			type: 'GET',
			data: {
				query: this.searchInp.value,
				id: id,
				page: this.pageNo,
				type: this.type,
				viewType: this.currentViewType,
				mediaFilter: this.mediaFilter,
				smartId: this.smartId,
				sort: this.sort
			},
			beforeSend: () => iwCore.loading(true),
			complete: () => {
				iwCore.loading(false);
				iwCore.removeClassName(document.body, 'init-load');
				this.loading = false;
			},
			success: (e: any) => {
				if (e.success) {
					if (id) {
						this.renderRecords(e);
					} else {
						this.renderCollections(e);
					}
					iwToolTips.reInit();
				} else {
					this.renderError();
				}
			},
			error: () => this.renderError()
		})
	}

	/**
	 * Create the media based filter button
	 * @param btnClass
	 * @param toolTip
	 * @param btnText
	 * @param type
	 * @private
	 */
	private filterTagButton(btnClass: string, toolTip: string, btnText: string, type: string): HTMLElement {
		let collectionFilterAudio = iwUI.createEl('button', {class: 'filter-tag iw_tool_tip_link ' + btnClass,
																	'data-tool-tip': iwi18n.gettext(undefined, toolTip)});
		collectionFilterAudio.textContent = iwi18n.gettext(undefined, btnText);
		EVENT.attach(collectionFilterAudio, 'click', this.changeMediaFilter.bind(this, type));
		return collectionFilterAudio;
	}

	/**
	 *
	 * @protected
	 */
	protected view(): void {
		this.header = iwUI.createEl('div', {class: 'head'});
		this.cFilterControl = iwUI.createEl('button', {class: 'icon-btn c-filter-control'});
		this.cSearchControl = iwUI.createEl('button', {class: 'icon-btn c-search-control', 'aria-label':iwi18n.gettext('collections', 'Open search') });
		this.collectionFilter = iwUI.createEl('div', {id: 'filter-control',
																	class: 'c-filter iwSlideSection'});
		this.emptyCollection = iwUI.createEl('div', {class: 'c-empty-collection'});
		this.emptyCollectionContent = iwUI.createEl('div', {class: 'c-empty-content'});
		this.emptyCollectionsTitle = iwUI.createEl('h2', {class: 'c-empty-title'});
		this.emptyCollectionsTxt = iwUI.createEl('p', {class: 'c-empty-txt'});
		this.emptyCollectionTitle = iwUI.createEl('h2', {class: 'c-empty-title'});
		this.emptyCollectionTxt = iwUI.createEl('p', {class: 'c-empty-txt'});

		this.errorCollectionTitle = iwUI.createEl('h2', {class: 'c-empty-title'});
		this.errorCollectionTxt = iwUI.createEl('p', {class: 'c-empty-txt'});

		this.searchBarContainer = iwUI.createEl('div', {class: 'c-search-bar'});
		this.searchInp = iwUI.createEl('input', {class: 'c-search-input',
																id: 'collections-search-input',
																placeholder: iwi18n.gettext('collections', 'Search %1', this.title.toLowerCase()),
																type: 'search',
																autocomplete: 'off',
																for: 'collections-search-input'});
		this.searchLbl = iwUI.createEl('label', {class: 'c-search-lbl'});
		this.cHeader = iwUI.createEl('div', {class: 'c-header'});
		this.cActions = iwUI.createEl('div', {class: 'c-actions'});
		this.cHeaderTitle = iwUI.createEl('h2', {class: 'c-header-title'});
		this.collectionTitleEl = iwUI.createEl('span', {class: ''});
		this.bBody = iwUI.createEl('div', {class: 'results-view', id: 'resultsViewWrapper'});
		this.itemsWrap = iwUI.createEl('div', {class: 'results-items'});
		this.frag = document.createDocumentFragment();

		this.resultsView = new ResultViews(this.bBody, this.currentViewType, [ViewType.grid, ViewType.list, ViewType.playlist]);

		this.mainContainer.className = 'c-panel';

		this.searchLbl.setAttribute('for','collections-search-input')
		this.searchLbl.textContent = iwi18n.gettext('collections', 'Search %1', this.title.toLowerCase());
		this.cFilterControl.textContent = iwi18n.gettext('collections', 'Open filters');

		if (this.isCollectionView) {
			this.collectionTypeTitle = iwUI.createEl('span', {class: 'c-header-cType u-link'});
			this.collectionTypeTitle.textContent = this.title;
			this.cHeaderTitle.appendChild(this.collectionTypeTitle);
		}

		this.emptyCollectionTitle.textContent = iwi18n.gettext('collections', 'There are no %1 items here yet', iw.collectionsName);
		this.emptyCollectionTxt.textContent = iwi18n.gettext('collections', 'You can add items via record pages or search results');
		this.emptyCollectionsTitle.textContent = iwi18n.gettext('collections', 'There are no %1 here yet', iw.collectionsPluralName);
		this.emptyCollectionsTxt.textContent = iwi18n.gettext('collections', 'You can create new %1 via record pages or search results', iw.collectionsPluralName);
		this.errorCollectionTitle.textContent = iwi18n.gettext('collections', 'Oops something went wrong...');
		this.errorCollectionTxt.textContent = iwi18n.gettext('collections', 'Please check back later');

		this.collectionFilter.appendChild(this.filterTagButton('filter-tag--all',iwi18n.gettext('collections', 'Filter All'),iwi18n.gettext(undefined, 'All'),''));
		this.collectionFilter.appendChild(this.filterTagButton('filter-tag--audio',iwi18n.gettext('collections', 'Filter Audio'),iwi18n.gettext(undefined, 'Audio'),'audio'));
		this.collectionFilter.appendChild(this.filterTagButton('filter-tag--doc',iwi18n.gettext('collections', 'Filter Documents'),iwi18n.gettext(undefined, 'Documents'),'document'));
		this.collectionFilter.appendChild(this.filterTagButton('filter-tag--vid',iwi18n.gettext('collections', 'Filter Videos'),iwi18n.gettext(undefined, 'Videos'),'video'));
		this.collectionFilter.appendChild(this.filterTagButton('filter-tag--clip',iwi18n.gettext('collections', 'Filter Clips'), iwi18n.gettext('collections', 'Clips'),'clip'));
		this.collectionFilter.appendChild(this.filterTagButton('filter-tag--img',iwi18n.gettext('collections', 'Filter Images'),iwi18n.gettext(undefined, 'Images'),'image'));
		this.collectionFilter.appendChild(this.filterTagButton('filter-tag--social',iwi18n.gettext('collections', 'Filter Social'),iwi18n.gettext('collections', 'Social Media'),'social'));

		this.cHeader.appendChild(this.cHeaderTitle);
		//this.cHeader.appendChild(this.collectionFilter);

		this.searchBarContainer.appendChild(this.searchLbl);
		this.searchBarContainer.appendChild(this.searchInp);
		this.searchBarContainer.appendChild(this.cSearchControl);
		
		this.mainContainer.appendChild(this.searchBarContainer);
		//this.mainContainer.appendChild(this.cFilterControl);
		this.mainContainer.appendChild(this.cHeader);
		this.mainContainer.appendChild(this.cActions);
		// this.mainContainer.appendChild(this.downloadBtn);
		this.mainContainer.appendChild(this.resultsView.view());
		this.bBody.appendChild(this.itemsWrap);
		this.mainContainer.appendChild(this.bBody);
	}

	/**
	 * Render list of collections
	 * @param collections
	 * @private
	 */
	private renderCollections(collections: any): void {
		if (this.collectionsData) {
			this.collectionsData.items = this.collectionsData.items.concat(collections.items);
		} else {
			this.collectionsData = collections;

			this.sortEl = iwUI.formSelectInput('collections-sort', iwi18n.gettext(undefined, 'Sort: '), {
				options: this.sortOpts,
				selectedValue: this.sort,
				onchange: (e: any) => {
					this.sort = this.sortOpts[e.target.options[e.target.selectedIndex].textContent];
					this.collectionsData.items = [];
					this.pageNo = 0;
					iwCore.clearElement(this.itemsWrap);
					this.getData();
				}
			});

			this.cHeader.append(this.sortEl);
		}

		if (collections.items.length) {
			iwCore.removeClassName(this.mainContainer, 'c-panel--empty');
			collections.items.forEach((item: any) => {
				let collectionItem = new CollectionResult(item, () => this.openCollection(item), this.currentViewType);
				this.itemsWrap.appendChild(collectionItem.mainContainer);
				this.setViewClassName(this.bBody);
			});
		} else {
			this.renderEmpty();
		}

		EVENT.custom('collection', {action: 'render'});
	}

	/**
	 * Sort collection item
	 *
	 * @param collectionId <Number> Collection ID
	 * @param clipID <Number> Clip ID
	 * @param newPos <Number> New item position after being sorted
	 * @private
	 */
	private sortCollectionItem(collectionId: number | string, clipID: Number, newPos: Number): void {
		iwCore.ajax({
			type: 'POST',
			dataType: 'json',
			url: '/collection/reorderitem',
			data: {
                collectionID: collectionId,
				clipID: clipID,
				clipPos: newPos
			},
			beforeSend: () => iwCore.loading(true),
			success: () => {
				iwCore.loading(false);
				iwNotifications.success(iwi18n.gettext('collections', 'Collection item has been moved'));
			},
			error: () => {
				iwNotifications.success(iwi18n.gettext('collections', 'There was an error moving the collection item'));
			}
		})
	}

	/**
	 * Render list of records in a collection
	 * @private
	 * @param data
	 */
	private renderRecords(data: any) {
		let newItems = data.collection.items,
			sortHandle: string = null;

		switch (this.currentViewType) {
			case 0:
				sortHandle = '.searchHit-item-handle';
				break;
			case 1:
				sortHandle = '.results-tile';
				break;
		}

		if (data.initLoad && this.currentCollection === null) {
			let breakPoint = iwCore.browser.breakPoint(window.innerWidth, window.innerWidth);
			if (breakPoint === 'desktop') {
				this.mainContainer.classList.add('iPanel-active');
			}

			this.currentCollection = data.collection;
			this.smartId = data.collection.smartId;

			this.infoPanel = new InfoPanel(this.currentCollection);
			
			this.recordSelection = new CollectionSelection(this.currentCollection);
			this.recordSelection.updateCanEdit();

			EVENT.attach(this.infoPanel.panel, 'InfoPanelOpen', (e: CustomEvent) => {
				if (e.detail.isOpen) {
					this.mainContainer.classList.add('iPanel-active');
				} else {
					this.mainContainer.classList.remove('iPanel-active');
				}
				this.resize();
			});

			this.renderTitle();
			this.setViewClassName(this.bBody);

			if (this.isCollectionView) {
				this.collectionCtx();
			}

			// acl editor button
			if (this.currentCollection.canEdit && data.aclBtn.length) {
				let btnParent = document.createElement('p');
				btnParent.innerHTML = data.aclBtn;
				this.cActions.appendChild(btnParent.firstChild);

				// since the btn is a string we need to find it in the dom after its added so the event is attached properly
				this.aclBtn = document.getElementsByClassName('acl_update_link')[0];

				// for the simple editor
				EVENT.attach(this.aclBtn,'ACLOptionUpdated', (e: CustomEvent) => {
					iwCore.loading(true);
					window.location.reload();
				});

				// for the advanced editor
				EVENT.attach(document,'AdvancedACLSaved', (e: CustomEvent) => {
					iwCore.loading(true);
					window.location.reload();
				});
			}

			if (!iw.isGuest && !this.currentCollection.isAnonLink) {
				this.shareLink = new ShareLink(this.currentCollection, this.currentCollection.publicUrl, this.smartId);
				this.cActions.insertBefore(this.shareLink.container, this.cActions.firstChild);
			}

			this.mainContainer.prepend(this.recordSelection.mainContainer);
			this.mainContainer.insertBefore(this.infoPanel.panel, this.searchBarContainer);
			this.mainContainer.appendChild(this.infoPanel.mainContainer);
		} else {
			this.currentCollection.items = this.currentCollection.items.concat(newItems);
		}

		this.recordSelection.hitListCount = this.currentCollection.numHits;

		if (newItems.length) {
			// Don't sort smart collections
			if (!this.smartId && data.initLoad && !this.currentCollection.isAnonLink) {
				this.sortableInstance = new Sortable(this.itemsWrap, {
					animation: 150,
					handle: sortHandle,
					delay: 100,
					filter: '.smart-item',
					delayOnTouchOnly: true, // only delay if user is using touch
					touchStartThreshold: 4,
					onEnd: (ev: any) => {
						// Only sort when the position really changes
						if (ev.newIndex !== ev.oldIndex) {
							this.sortCollectionItem(this.currentCollection.id, ev.item.dataset.clipid, ev.newIndex);

							// first we grab the item that was moved from the array, and delete it from the array
							let item = this.currentCollection.items.splice(ev.oldIndex, 1);

							// then we take that item that was deleted, and place it into the array at the position the user placed it in,
							// so now our array is in the correct order as the user has sorted it
							this.currentCollection.items.splice(ev.newIndex, 0, item[0]);

							// now that the array is in the correct order, we can just loop through the items in order and
							// reset the position
							this.currentCollection.items.forEach((f: any, index: number) => {
								f.position = index;
							});

							EVENT.custom('collectionSorted', {
								oldIndex: ev.oldIndex,
								newIndex: ev.newIndex
							});
							EVENT.custom('CollectionInfo', {action: 'update'});
						}
					}
				})
			}

			newItems.forEach((item: any) => {
				let record = new RecordResult(
					item,
					this.currentCollection,
					this.currentViewType,
					this.showDownloadCheck(this.currentCollection.showOrder, item.Fields.mediaType),
					this.showDownloadCheck(this.currentCollection.showOrderFor, item.Fields.mediaType),
					this.currentCollection.showOrderOnBehalfOf,
					this.currentCollection.canEdit,
					item.canEditItem,
					() => {
						if (this.infoPanel.activeItem !== 'mediaItem') {
							let item = this.infoPanel.navDrawer.getItemById('mediaItem');
							this.infoPanel.navDrawer.changeItem(item);
						}

						EVENT.custom('SetActiveInfo', {position: item.position});
					},
					this.recordSelection.selections.isEntireHitList,
					item.position
				);
				this.itemsWrap.appendChild(record.mainContainer);
			});

			this.recordSelection.checkSelectAll(); // if we are loading more, make sure the 'select all' tick shows on the batch actions now instead of the unselect
			this.infoPanel.update();

			let viewGroup = [
					{name: iwi18n.gettext(undefined, 'View'), icon: 'iw-icon-view', linkRef: 'iwlinkurl'},
					{name: iwi18n.gettext('collections', 'View original'), icon: 'iw-icon-view-parent', linkRef: 'iworiginalurl', condition:'iwisclip'}
				],
				editGroup = [
					{name: iwi18n.gettext('collections', 'Edit record'), icon: 'iw-icon-edit', cbFn: this.editRecord.bind(this), condition: 'iwusercanedit'},
					{name: iwi18n.gettext('collections', 'Edit caption'), icon: 'iw-icon-edit', cbFn: this.editClipTitle.bind(this), condition:'iwcaneditcaption'},
					{name: iwi18n.gettext('collections', 'Edit in and out points'), icon: 'iw-icon-edit', linkRef: 'iweditlinkurl', condition:'iwcaneditclip'}
				],
				actionGroup = [
					{name: iwi18n.gettext('baskets', 'Add to basket'), icon: 'iw-icon-basket', cbFn: (params: any) => {
							EVENT.custom('addItemToBasket', {
								recordID: params.iwrecordid,
								mediaID: params.iwmediaid,
								collectionItemID: params.iwclipid,
							})
						}, condition: 'iwbasketsenabled'},
					{name: iwi18n.gettext(undefined, 'Run workflow'), icon: 'iw-icon-workflow', cbFn: this.runWorkflow.bind(this), condition: 'iwcanrunworkflow'},
					{name: iwi18n.gettext(undefined, 'Download'), icon: 'iw-icon-download', cbFn: 'CISDownloadMedia.collectionDownload', condition: 'iwshowdl'},
					{name: iwi18n.gettext(undefined, 'Add to %1', iw.collectionsName), icon: 'iw-icon-collection-add', cbFn: ' CISCollectionsLink.fireCollectionLink', condition: 'iwcreatecollection'},
					{name: iwCore.capitaliseFirst(iwi18n.gettext('collections', '%1 a download...', iw.ordersTitleTerm)), icon: 'iw-icon-order', cbFn: 'CISSendJobWidgets.send', condition: 'iwshoworder'},
					{name: iwCore.capitaliseFirst(iwi18n.gettext('collections', '%1 a download for...', iw.ordersTitleTerm)), icon: 'iw-icon-order', cbFn: 'CISSendJobWidgets.sendFor', condition: 'iwshoworderfor'},
					{name: iwCore.capitaliseFirst(iwi18n.gettext('collections', '%1 a download for...', iw.ordersTitleTerm)), icon: 'iw-icon-order', cbFn: 'CISDownloadMedia.orderbehalfDownload', condition: 'iwshoworderonbehalfof'},
				].concat(this.getEnquiryMenuGroup()),
				deleteGroup = [
					{name: iwi18n.gettext('collections', 'Remove from %1', iw.collectionsName), icon: 'iw-icon-clear', delete: true, cbFn: this.removeItem.bind(this), condition: 'iwcanremove'}
				];

			iwMenu.setMenuArray('recordCtx', {
				title: iwCore.capitaliseFirst(iwi18n.gettext('collections', '%1 item options', iw.collectionsName)),
				groups: [viewGroup, editGroup, actionGroup, deleteGroup]
			});

		} else if (!this.currentCollection.items.length) {
			this.renderEmpty(data.collection);
		}
		EVENT.custom('collection', {action: 'render', id: this.currentCollection.id});
		this.resize();
	}

	/**
	 *
	 * @param permission
	 * @param mediaType
	 * @private
	 */
	private showDownloadCheck(permission: boolean, mediaType: string): boolean {
		switch(mediaType) {
			case 'video':
				return permission && this.currentCollection.hasVideoWorkflow;
			case 'audio':
				return permission && this.currentCollection.hasAudioWorkflow;
		}

		return false;
	}

	/**
	 *
	 * @param params
	 * @param el
	 * @private
	 */
	private editClipTitle(params: any, el: any) {
		let form = iwUI.createEl('DIV', {class: 'modal-form-group modal-form-group--stacked'}),
			label = iwUI.createEl('LABEL', {class: 'modal-label'}),
			input = iwUI.createEl('INPUT', {class: 'modal-input'});

		label.textContent = iwi18n.gettext('collections', 'Edit caption');
		input.value = decodeURIComponent(params.iwcaption || params.iwrecordname || '');

		form.append(label, input)

		iwModal.create(el, 'clipCaptionCollection', {
			title: iwi18n.gettext('collections', 'Edit caption'),
			type: 'confirm',
			modalBody: form,
			buttonLabel: iwi18n.gettext('collections', 'Save'),
			buttonClick: () => {
				this.renameCollectionItem(params.iwclipid, params.iwcollectionid, input.value, params.iwposition);
			}
		});
	}

	/**
	 *
	 * @param clipID
	 * @param collectionID
	 * @param caption
	 * @param position
	 * @private
	 */
	private renameCollectionItem(clipID: number, collectionID: number, caption: string, position: number) {
		iwCore.ajax({
			type: 'POST',
			dataType: 'json',
			url: '/collection/renameitem',
			data: {
				clipID: clipID,
				collectionid: collectionID,
				caption: caption,
				clipPos: position
			},
			beforeSend: () => iwCore.loading(true),
			success: function( data:any ) {
				if (data.success) {
					iwNotifications.alert(data.notification.description, data.notification.title);
					EVENT.custom('clip',{action: 'edit'});
					let li = document.getElementById('collection-item-' + clipID);
					if (li) {
						let menu = li.getElementsByClassName('IWmenu_link')[0],
							title = li.getElementsByClassName('results-tile-title')[0],
							titleList = li.getElementsByClassName('list-item-title')[0];

						if (menu) {
							menu.setAttribute('data-iwcaption', caption);
						}
						if (title) {
							title.textContent = caption;
						}
						if (titleList) {
							titleList.textContent = caption;
						}
					}
				} else {
					iwNotifications.error(data.error);
				}
				iwModal.hide('clipCaptionCollection');
				iwCore.loading(false);
			},
			error: function(data: any) {
				let msg = iwi18n.gettext(undefined, 'Could not save changes');
				if (typeof data.error === 'string') {
					msg = data.error;
				}
				iwModal.hide('clipCaptionCollection');
				iwNotifications.error(msg);
				iwCore.loading(false);
			}
		});
	}

	/**
	 * When we open the filter the page height needs to increase so call function to recalculate
	 */
	private openFilterActions() {
		iwCore.slideElement(this.collectionFilter, null, function(this: CollectionPanel) {this.resize()}.bind(this));
	}

	/**
	 * Set class name based on the view type we're in
	 * @param el
	 */
	private setViewClassName(el: HTMLElement) {
		switch (this.currentViewType) {
			case ViewType.list:
				iwCore.addClassName(el, 'results-view--list');
				iwCore.removeClassName(el, 'results-view--grid');
				break;
			case ViewType.grid:
				iwCore.addClassName(el, 'results-view--grid');
				iwCore.removeClassName(el, 'results-view--list');
				break;
		}
	}

	/**
	 *
	 * @private
	 */
	private collectionCtx() {
		this.cContextMenu = iwMenu.createMenuLink('collectionCtx', CollectionsViewer.getCollectionCtxParams(this.currentCollection));

		// overwrite content as we don't need an icon or text here.
		this.cContextMenu.textContent = '';
		iwCore.addClassName(this.cContextMenu, 'c-context-menu collection-ctx');

		this.cActions.appendChild(this.cContextMenu);
	}

	/**
	 * Update menu context data when collection title or description is changed.
	 * @private
	 */
	private replaceCollectionCtx() {
		let newMenuCtx = iwMenu.createMenuLink('collectionCtx', CollectionsViewer.getCollectionCtxParams(this.currentCollection));

		newMenuCtx.textContent = '';
		iwCore.addClassName(newMenuCtx, 'c-context-menu collection-ctx');

		this.cActions.replaceChild(newMenuCtx, this.cContextMenu);
		this.cContextMenu = newMenuCtx;
	}

	/**
	 * Create an error in place of the collections/records view
	 * @private
	 */
	private renderError() {
		iwCore.clearElement(this.itemsWrap);
		iwCore.addClassName(this.mainContainer, 'c-panel--error');
		this.emptyCollectionContent.innerHTML = '';
		this.emptyCollectionContent.appendChild(this.errorCollectionTitle);
		this.emptyCollectionContent.appendChild(this.errorCollectionTxt);
		this.emptyCollection.appendChild(this.emptyCollectionContent);
		this.itemsWrap.appendChild(this.emptyCollection);
	}

	/**
	 * Create an error page
	 * @private
	 */
	private renderEmpty(collection?: any) {
		if (collection) {
			//if there are no collection items in a collection
			this.renderTitle(collection.Name);
			iwCore.addClassName(this.mainContainer, 'c-panel--empty');
			this.emptyCollectionContent.appendChild(this.emptyCollectionTitle);
			if (this.currentCollection.isAnonLink) {
				this.emptyCollectionContent.appendChild(this.emptyCollectionTxt);
			}
			this.emptyCollection.appendChild(this.emptyCollectionContent);
			this.itemsWrap.appendChild(this.emptyCollection);
		} else {
			//if there are no collections (overview)
			iwCore.addClassName(this.mainContainer, 'c-panel--empty');
			this.emptyCollectionContent.appendChild(this.emptyCollectionsTitle);
			this.emptyCollectionContent.appendChild(this.emptyCollectionsTxt);

			if(this.type === 2) {
				this.emptyCollectionsTitle.textContent = iwi18n.gettext('collections', 'No %1 to see yet', iw.collectionsPluralName);
				this.emptyCollectionsTxt.textContent = iwCore.capitaliseFirst(iwi18n.gettext('collections', '%1 shared with you will appear here.', iw.collectionsPluralName));
			}

			if(this.searchInp.value !== '') {
				iwCore.addClassName(this.mainContainer, 'c-panel--noResults');
				this.emptyCollectionsTitle.textContent = iwi18n.gettext('collections', 'No %1 match your query', iw.collectionsPluralName);
				this.emptyCollectionsTxt.textContent = iwi18n.gettext('collections', 'Try a different query.');
			}

			this.emptyCollection.appendChild(this.emptyCollectionContent);
			this.itemsWrap.appendChild(this.emptyCollection);
			}
	}

	/**
	 * Change media filter
	 * @param mediaType
	 * @param e
	 * @private
	 */
	private changeMediaFilter(mediaType: string, e: Event) {
		if (this.mediaFilter !== mediaType) {
			iwCore.clearElement(this.itemsWrap);

			let parent = iwCore.findParentByClassName(e.target, 'c-filter'),
				cActive = parent.getElementsByClassName('is-active')[0];

			iwCore.removeClassName(cActive, 'is-active');
			iwCore.addClassName(e.target, 'is-active');

			this.mediaFilter = mediaType;
			this.getData();
		}
	}

	/**
	 * Delete this collection
	 * @param params
	 * @param el
	 * @param e
	 * @private
	 */
	private deleteCollection(params: any, el: HTMLElement, e: Event) {
		if (params.iwcollectionid) {
			let that = this;
			iwModal.create(el, 'deleteCollection', {
				title: iwi18n.gettext(undefined, "Delete %1", iw.collectionsName),
				type: 'delete',
				message: iw.deleteDialogText,
				buttonLabel: iwi18n.gettext(undefined, "Delete %1", iw.collectionsName),
				buttonClick: () => {
					iwCore.ajax({
						type: 'POST',
						dataType: 'json',
						url: '/collection/collectiondelete',
						data: {
							collectionID: params.iwcollectionid
						},
						beforeSend: () => iwCore.loading(true),
						complete: () => iwCore.loading(false),
						success: (data: any) => {
							if (!data.error) {
								iwModal.hide('deleteCollection');
								that.openCollections();
							} else {
								iwModal.get('deleteCollection').setError(iwi18n.gettext(undefined, 'Something went wrong, please try again later'));
							}
						}
					});
				}
			});
		}
	}

	/**
	 *
	 * @param params
	 * @param el
	 * @private
	 */
	private openFromContext(params: any, el: HTMLElement) {
		if (params.iwcollectionid) {
			this.openCollection({id: params.iwcollectionid});
		}
	}

	/**
	 * Edit this collection from the context menu
	 * @param params
	 * @param type - 'title' or 'description'
	 * @private
	 */
	private editFromContext(params: any, type: string) {
		let switchMenu = () => {
			if (this.infoPanel.navDrawer.currentItem.id !== 'info') {
				const a = this.infoPanel.navDrawer.getItemById('info');
				this.infoPanel.navDrawer.changeItem(a);
			}
		};

		if (this.currentCollection) {
			switchMenu();
			EVENT.custom('CollectionInfo', {action: type});
		} else {
			this.openCollection({id: params.iwcollectionid});

			let edit = true,
				evt = (e: CustomEvent) => {
					if (e.detail.action === 'render' && e.detail.id !== null && edit) {
						requestAnimFrame(() => {
							switchMenu();
							EVENT.custom('CollectionInfo', {action: type});
							EVENT.remove(document, 'collection', evt);
							edit = false;
						});
					}
				};

			EVENT.attach(document, 'collection', evt);
		}
	}

	/**
	 * Open enquire modal
	 * @param zoneId
	 * @param params
	 * @param el
	 * @private
	 */
	private enquire(zoneId: any, params: any, el: HTMLElement) {
		let data: any = {
			collectionID: params.iwcollectionid,
			collectionURL: decodeURIComponent(params.iwcollection_public_url),
			collectionHits: params.iwcollectionhits
		};

		// if they are using the new form in the cPanel
		if (EnquiryData.data && EnquiryData.data[zoneId]) {
			let parseJson = JSON.parse(EnquiryData.data[zoneId]);
			CISDynamicForm.init(parseJson.elementId,
				parseJson.encryptId,
				parseJson.email,
				parseJson.headerText,
				parseJson.submitText,
				parseJson.successText,
				null,
				'',
				parseJson.dynamicFormItems,
				{
					collectionID: data.collectionID,
					collectionName: params.iwcollectionname,
					collectionDescription: params.iwdescription,
					collectionCreationDate: params.iwcreationdate,
					collectionModifiedDate: params.iwmodifieddate,
					collectionUrl: data.collectionURL,
					collectionHits: data.collectionHits,
					recordName: params.iwrecordname ?? null,
					recordUrl: params.iwrecordid ? ('/record/' + params.iwrecordid) : null
				});
		} else if (params.iwcollectionid) {
			if (params.iwclipid) {
				data.clipID = params.iwclipid;
				data.isClip = !!parseInt(params.iwisclip, 10);
				data.recordID = params.iwrecordid;
				data.mediaID = params.iwmediaid;
				data.caption = params.iwcaption;
				data.itemURL = decodeURIComponent(params.iwlinkurl || params.iwrecordurl);
			}

			iwModal.create(el, "collectionEnquire", {
				aurl: "/collection/enquireform",
				type: "ajax-body",
				title: iwi18n.gettext(undefined, "Enquire"),
				event: 'collection-enquire',
				data: JSON.stringify(data)
			});
		}
	}

	/**
	 * Open a collection
	 * @param item
	 * @private
	 */
	private openCollection(item: any) {
		iwCore.clearElement(this.itemsWrap);
		iwCore.addClassName(document.body, 'init-load');

		if (this.cHeader && this.cHeader.contains(this.sortEl)) {
			this.cHeader.removeChild(this.sortEl);
		}
		this.searchInp.placeholder = iwi18n.gettext('collections', 'Search %1', item.title);
		this.mainContainer.className = 'c-panel';
		this.collectionsData = null;
		this.pageNo = 0;
		this.searchInp.value = '';
		this.getData(item.id)
		this.addNavigation(item.id);
	}

	/**
	 * Go back to collection view
	 * @private
	 */
	public openCollections(load: boolean = true) {
		iwCore.toggleClassName(this.collectionFilter, 'hide');
		iwCore.clearElement(this.itemsWrap);
		iwCore.addClassName(document.body, 'init-load');
		this.searchInp.placeholder = iwi18n.gettext('collections', 'Search %1', this.title.toLowerCase());

		this.mainContainer.className = 'c-panel';

		if (this.infoPanel) {
			this.infoPanel.close();

			if (this.infoPanel.panel.parentElement) {
				this.mainContainer.removeChild(this.infoPanel.panel);
				this.mainContainer.removeChild(this.infoPanel.mainContainer);
			}
		}

		if (this.cContextMenu && this.cContextMenu.parentElement) {
			this.cContextMenu.parentElement.removeChild(this.cContextMenu);
		}

		if (this.collectionTitleEl.parentElement) {
			this.collectionTitleEl.parentElement.removeChild(this.collectionTitleEl);
		}

		if (this.aclBtn && this.aclBtn.parentElement && this.cActions.contains(this.aclBtn.parentElement)) {
			this.cActions.removeChild(this.aclBtn.parentElement);
		}

		if (this.shareLink && this.shareLink.container.parentElement) {
			this.shareLink.container.parentElement.removeChild(this.shareLink.container);
		}

		if (this.recordSelection) {
			this.recordSelection.destroy();
			if (this.recordSelection.mainContainer.parentElement === this.mainContainer) {
				this.mainContainer.removeChild(this.recordSelection.mainContainer);}
		}

		if (this.cHeader && this.cHeader.contains(this.sortEl)) {
			this.cHeader.removeChild(this.sortEl);
		}

		this.cContextMenu = null;
		this.currentCollection = null;
		this.collectionsData = null;
		this.mediaFilter = '';
		this.pageNo = 0;
		this.searchInp.value = '';
		this.recordSelection = null;
		this.smartId = null;
		this.infoPanel = null;

		if (load) {
			this.getData();
			this.addNavigation();
			this.pageHeight();
		}
	}

	/**
	 *
	 * @private
	 */
	public addNavigation(id?: number | string, isHistoric: boolean = false) {
		let data = {
			id: id,
			type: this.type
		},
			url = '/collections/' + (id ?? '');

		if (isHistoric) {
			// ensure that we add the type to the state in case we are coming from a link or refresh
			window.history.replaceState(data, 'Title', url);
		} else {
			window.history.pushState(data, 'Title', url);
		}
	}

	/**
	 *
	 * @private
	 */
	private renderTitle(title?: string) {
		iwCore.addClassName(this.collectionTitleEl, 'c-header-cName');
		this.collectionTitleEl.textContent = title ?? this.currentCollection.title;
		this.cHeaderTitle.appendChild(this.collectionTitleEl);
	}

	/**
	 * Calculate the page height
	 * @public
	 */
	public pageHeight(): number {

		let	topArea = document.getElementById('my-collections').getBoundingClientRect(),
			cContainer = document.getElementById('my-collections'),
			topAreaHeight = Math.ceil(topArea.y),
			cContainerStyle = getComputedStyle(cContainer),
			cContainerBorderTop = iwCore.ExtractNumber(cContainerStyle.getPropertyValue('border-top')),
			title = this.cHeader,
			titleHeight = Math.ceil(title.offsetHeight),
			bodyStyle = getComputedStyle(this.bBody),
			margin = iwCore.ExtractNumber(bodyStyle.getPropertyValue('margin-top')),
			marginHeight = Math.ceil(margin),
			searchBar = this.searchBarContainer.offsetHeight,
			searchBarHeight = Math.ceil(searchBar),
			searchBarMargin = iwCore.ExtractNumber(getComputedStyle(this.searchBarContainer).getPropertyValue('margin-bottom')),
			searchBarMarginHeight = Math.ceil(searchBarMargin),
			titleMargin = iwCore.ExtractNumber(getComputedStyle(title).getPropertyValue('margin-bottom')),
			titleMarginHeight = Math.ceil(titleMargin),
			baseHeight =  window.scrollY + window.innerHeight - topAreaHeight - cContainerBorderTop,
			height = baseHeight - titleHeight - titleMarginHeight - searchBarHeight - searchBarMarginHeight - marginHeight,
			breakPoint = iwCore.browser.breakPoint(window.innerWidth, window.innerWidth);

		if (breakPoint === 'mobile') {
			height = height + topAreaHeight;
		}

		this.bBody.style.height = height + 'px';

		return baseHeight;
	}

	/**
	 * Removes an item from a collection
	 * @param params
	 * @param el
	 * @private
	 */
	private removeItem(params: any, el: HTMLElement) {
		if (params.iwcollectionid && params.iwclipid) {
			let data: any = {collectionID: params.iwcollectionid,
							clipID: params.iwclipid,
							mediaID: params.iwmediaid,
							mediaType: params.iwmediatype};

			iwModal.create(el, 'deleteItemModal', {
				title: iwi18n.gettext(undefined, "Remove item"),
				type: 'delete',
				message: iwi18n.gettext(undefined, 'Are you sure you want to remove this item from your %1?', iw.collectionsName),
				buttonLabel: iwi18n.gettext(undefined, "Remove item"),
				buttonClick: () => {
					iwCore.ajax({
						data: data,
						url: '/collection/deleteitem',
						type: 'POST',
						dataType: 'json',
						beforeSend: () => iwCore.loading(true),
						complete: () => iwCore.loading(false),
						success: (data:any) => {
							if (data.success) {
								//	EVENT.custom('RecordResult', {deleteItem: this});
								this.cleanAfterDelete(data.id);
								iwModal.hide('deleteItemModal');
							} else {
								let deleteModal = iwModal.get("deleteItemModal");
								if (deleteModal) {
									deleteModal.setError({msg: data.error});
								} else {
									iwNotifications.error(data.error);
								}
							}
						},
					});
				}
			});
		}
	}

	/**
	 *
	 * @param id
	 * @private
	 */
	private cleanAfterDelete(id: number) {
		let index = this.currentCollection.items.findIndex((f: any) => f.clipID === +id);
		this.currentCollection.items.splice(index, 1);
		let el = document.getElementById('collection-item-' + id);
		el.parentElement.removeChild(el);
		this.currentCollection.numHits--;

		// update the context menu with the new number of hits
		//let contextMenu = document.querySelector('[data-iwcollectionid="' + this.currentCollection.id + '"]');
		let contextMenu = document.querySelector('.iwMenu_collectionCtx[data-iwcollectionid="' + this.currentCollection.id + '"]');
		contextMenu.setAttribute('data-iwcollectionhits', this.currentCollection.numHits.toString());

		if (this.currentCollection.numHits === 0) {
			this.renderEmpty(this.currentCollection);
		}

		EVENT.custom('CollectionInfo', {action: 'update',});
	}

	/**
	 * Get our enquire data for our new DyanmicForm Enquire (inCpanel)
	 * @private
	 */
	private getEnquireData() {
		iwCore.ajax({
			type: 'GET',
			url: '/collections/getenquiredata',
			success: (e: any) => {
				let renderLegacyForm = e.renderLegacyForm || false;

				if (e.success) {
					EnquiryData.data = !iwCore.isEmptyObject(e.data) ? e.data : {};
				}

				// should we render the legacy form (if enquiries enabled and there are NO dynamic forms on system for enquiries
				EnquiryData.isLegacy = renderLegacyForm

				// we need to wait for response now before we create menu items,
				// as enquiry items are dependent on the results from this request
				this.setMenuArray();
			}
		})
	}

	/**
	 *
	 * @param params
	 * @param el
	 * @private
	 */
	private editRecord(params: any, el: HTMLElement) {
		// telling typescript this file does exist without creating circular references
		// @ts-ignore
		new EditMetadata(params.iwrecordid);
	}


	/**
	 *
	 * @param params
	 * @param el
	 * @private
	 */
	private runWorkflow(params: any, el: HTMLElement) {
		let data: any = {
			recordID: parseInt(params.iwrecordid ?? 0, 10),
			mediaID: parseInt(params.iwmediaid ?? 0, 10),
			clip: null,
		}

		if (params.iwisclip) {
			data.clip = {
				startFrame: params.iwstartframe,
				endFrame: params.iwendframe,
				title: params.iwcaption
			};
		}

		// if the media id isn't defined then we need to call mcc to get all the MO's from that record
		if (!data.mediaID) {
			CollectionSelection.getIdsForWorkflow(el, this.currentCollection, [params.iwclipid]);
		} else {
			iwRunWorkflow(el, new RunWorkflowConfig(null, data.mediaID, data.clip, null, data.recordID, null, null, this.currentCollection.title));
		}
	}

	/**
	 * Run workflow on the entire collection
	 * @param params
	 * @param el
	 * @private
	 */
	private runWorkflowOnAll(params: any, el: HTMLElement) {
		CollectionSelection.getIdsForWorkflow(el, {id: params.iwid, title: decodeURIComponent(params.iwtitle)}, null);
	}
}